import React, { Component } from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Navigation from "context/nav";
import './settings.css';

import Profile from "./profile";
import Access from "components/profile/access";
import ApiKeys from "components/profile/apiKeys";
import Limits from "components/profile/limits";
import Credentials from "components/profile/credentials";
import Admin from "./admin";

export default class BlobSettings extends Component {
  render() {
    if ( !this.props.org || !this.props.blob ) {
      return (<></>);
    }

    const sectionId = this.props.match.params.sectionId || "profile";

    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col sm={3}>
              <Card>
                <ListGroup variant="flush" className="blob-settings-navigation-list">
                  {"profile" === sectionId
                    ? <ListGroup.Item active>Profile</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsProfilePath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Profile</ListGroup.Item>
                      </Link>
                  }
                  {"access" === sectionId
                    ? <ListGroup.Item active>Access</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsAccessPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Access</ListGroup.Item>
                      </Link>
                  }
                  {"api-keys" === sectionId
                    ? <ListGroup.Item active>API Keys</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsApiKeysPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>API Keys</ListGroup.Item>
                      </Link>
                  }
                  {"credentials" === sectionId
                    ? <ListGroup.Item active>Credentials</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsCredentialsPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Credentials</ListGroup.Item>
                      </Link>
                  }
                  {"limits" === sectionId
                    ? <ListGroup.Item active>Limits</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsLimitsPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Limits</ListGroup.Item>
                      </Link>
                  }
                  {"admin" === sectionId
                    ? <ListGroup.Item active>Administration</ListGroup.Item>
                    : <Link to={Navigation.blobSettingsAdminPath(this.props.org, this.props.blob)}>
                        <ListGroup.Item>Administration</ListGroup.Item>
                      </Link>
                  }
                </ListGroup>
              </Card>
            </Col>
            <Col sm={9}>
              <div className={"profile" === sectionId ? "" : "hidden"}>
                <Profile
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  blob={this.props.blob}
                  blobInterface={this.props.blobInterface}
                />
              </div>
              <div className={"access" === sectionId ? "" : "hidden"}>
                <Access
                  history={this.props.history}
                  app={this.props.app}
                  profileInterface={{
                    loadProfile: () => {
                      return this.props.blobInterface.loadBlob();
                    }
                  }}
                  target={"blob"}
                  targetObject={this.props.blob}
                />
              </div>
              <div className={"api-keys" === sectionId ? "" : "hidden"}>
                <ApiKeys
                  history={this.props.history}
                  app={this.props.app}
                  target={"blob"}
                  targetId={this.props.blob.id}
                />
              </div>
              <div className={"credentials" === sectionId ? "" : "hidden"}>
                <Credentials
                  history={this.props.history}
                  app={this.props.app}
                  target={"blob"}
                  targetId={this.props.blob.id}
                />
              </div>
              <div className={"limits" === sectionId ? "" : "hidden"}>
                <Limits
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  blob={this.props.blob}
                  target={"blob"}
                  targetIds={[this.props.org.id, this.props.blob.id]}
                />
              </div>
              <div className={"admin" === sectionId ? "" : "hidden"}>
                <Admin
                  history={this.props.history}
                  app={this.props.app}
                  org={this.props.org}
                  blob={this.props.blob}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
